import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OSMPlace } from '../models/osm-place.model';

@Injectable({
  providedIn: 'root'
})
export class OpenStreetMapNominatimService {
  searchTerm: string;
  osmPlaces: OSMPlace[];
  SEARCH_BBOX = '-4.803829,41.592858,-4.681757,41.696692'; // BBOX en el que buscar Places
  SEARCH_BY_NAME_PARAMS = {
    VERB: 'search',
    PARAMS: 'format=json&bounded=1&countrycodes=es',
  };
  SEARCH_BY_COORD_PARAMS = {
    VERB: 'reverse',
    ZOOM: 'zoom=18', // STREET
    ADDRESS_DETAIL: 'addressdetails=1',
  };
  constructor(
    private httpClient: HttpClient
  ) { }

  /**
   * Busca lugares en Nominatim limitada a BBOX
   * @param  {[type]}            searchTerm [description]
   * @return {Observable<any[]>}            [description]
   */
  searchPlacesbyName(searchTerm: string): Observable<any[]> {
    this.searchTerm = searchTerm;
    // busqueda de lugares limitado a bbox
    const osmApiURL = `${environment.nominatim_server.baseUrl}/${this.SEARCH_BY_NAME_PARAMS.VERB}/${this.searchTerm}?${this.SEARCH_BY_NAME_PARAMS.PARAMS}&viewbox=${this.SEARCH_BBOX}`;
    return this.httpClient.get<any[]>(osmApiURL);
  }

  /**
   * Busca los lugarles que hay en una coordenada
   * @param  {[type]}               coordLonLat [description]
   * @return {Observable<OSMPlace>}             [description]
   */
  searchPlacesbyCoordinates(coordLonLat: [number, number]): Observable<OSMPlace> {
    const params = `format=json&lon=${coordLonLat[0]}&lat=${coordLonLat[1]}&${this.SEARCH_BY_COORD_PARAMS.ZOOM}&${this.SEARCH_BY_COORD_PARAMS.ADDRESS_DETAIL}`;

    const osmApiURL = `${environment.nominatim_server.baseUrl}/${this.SEARCH_BY_COORD_PARAMS.VERB}?${params}`;
    return this.httpClient.get<OSMPlace>(osmApiURL);
  }
}
